import api from './client';

export interface WebhookEndpoint {
  id: string;
  url: string;
  events: string[];
  secret: string;
  description?: string;
  active: boolean;
  created_at: string;
}

export interface WebhookDelivery {
  id: string;
  endpoint_id: string;
  event_type: string;
  payload: object;
  status_code?: number;
  success?: boolean;
  attempt_count: number;
  last_attempted_at?: string;
  delivered_at?: string;
  error?: string;
}

export const webhooksApi = {
  list: () => api.get<{ data: WebhookEndpoint[] }>('/api/v1/webhooks'),
  create: (body: { url: string; events: string[]; secret?: string; description?: string }) =>
    api.post<{ data: WebhookEndpoint }>('/api/v1/webhooks', body),
  update: (id: string, body: Partial<WebhookEndpoint>) =>
    api.put<{ data: WebhookEndpoint }>(`/api/v1/webhooks/${id}`, body),
  delete: (id: string) => api.delete(`/api/v1/webhooks/${id}`),
  test: (id: string) =>
    api.post<{ data: { success: boolean; statusCode: number; responseTime: number } }>(
      `/api/v1/webhooks/${id}/test`
    ),
  deliveries: (id: string) =>
    api.get<{ data: WebhookDelivery[] }>(`/api/v1/webhooks/${id}/deliveries`),
  getApiKey: () => api.get<{ data: { hasKey: boolean; maskedKey: string | null } }>('/api/v1/settings/api-key'),
  regenerateApiKey: () =>
    api.post<{ data: { apiKey: string; maskedKey: string } }>('/api/v1/settings/api-key/regenerate'),
};
